'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var url = require('url');

var REFERRERS = ['google', 'yahoo', 'bing'];

function isSearchEngine(referrer) {
  if (typeof referrer === 'string') {
    var url$1 = url.parse(referrer, true, true);

    if (typeof url$1.hostname === 'string') {
      return url$1.hostname.split('.').slice(-3).reduce(function (result, domain) {
        return result || REFERRERS.includes(domain);
      }, false);
    }
  }

  return false;
}
/**
 * Hero Gaming SEO affiliate ID/Tag. Used to track organic search player
 * acquisition. Same for all brands.
 * @constant
 * @type {string}
 */


var SEO_BTAG = '654421_44B727F95F044AD482A0E3A2B3398401';
/**
 * Get NetRefer BTag from page URL
 * @param {string} referrer Request origin, usually `document.referrer`
 * @param {string} location Current location, e.g. `window.location.href`
 * @returns {?string} NetRefer BTag or `undefined`
 */

function getBtag(referrer, location) {
  if (isSearchEngine(referrer)) {
    return SEO_BTAG;
  }

  var url$1 = url.parse(location, true, true);
  return url$1.query.btag;
}

exports.SEO_BTAG = SEO_BTAG;
exports.getBtag = getBtag;
//# sourceMappingURL=get-btag.js.map
